module.exports = __webpack_public_path__ + "static/img/one.bd926ec5.png";